import { render, staticRenderFns } from "./ShapeTypeButton.vue?vue&type=template&id=3884f906&lang=pug&"
import script from "./ShapeTypeButton.vue?vue&type=script&lang=js&"
export * from "./ShapeTypeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShapeTypeButton.vue"
export default component.exports